import actionTypes from '../actions/types';
import { getModuleLocaleDataKey } from '../utils/i18n';

export const INITIAL_STATE = {
  locale: 'en',
  localeData: {},
};

const handleUpdateLocaleData = (state, { module, locale, data }) => {
  const localeDataKey = getModuleLocaleDataKey(module, locale);

  const localeData = {
    ...state.localeData,
    [localeDataKey]: { ...data },
  };
  return { ...state, localeData, locale };
};

export const reducer = (state, action) => {
  switch (action.type) {
    case actionTypes.SET_LOCALE_DATA:
      return handleUpdateLocaleData(state, action);
    default:
      return state;
  }
};
